import { useState } from "react";
import { getContrastingTextColor } from "../../util/ColorUtil";
import { colorPickerDefaults } from "../../helpers/colorPickerDefaults";
import useClickOutside from "../../hooks/useClickOutside";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEyeDropper } from "@fortawesome/free-solid-svg-icons";

const dropperDefaults = {
  color: "#ffffff",
  backgroundColor: "transparent",
};

const ColorPicker = ({
  initialColor,
  handleColor,
  display,
  alwaysOpen = false,
  onClose,
}) => {
  const [isPickerOpen, setIsPickerOpen] = useState(alwaysOpen || false);
  const [selectedColor, setSelectedColor] = useState(initialColor || "#000000");
  const dropdownRef = useClickOutside(() => {
    if (!alwaysOpen) {
      setIsPickerOpen(false);
    }
  });

  const handleOpenDropper = (e) => {
    e.preventDefault();
    const dropper = new window.EyeDropper();

    dropper
      .open()
      .then((colorSelectionResult) =>
        setSelectedColor(colorSelectionResult.sRGBHex)
      )
      .catch((err) => {
        if (err.name === "AbortError") {
        } else {
          console.error("Dropper", err);
        }
      });
  };

  const renderColors = () => {
    return colorPickerDefaults.map((color) => {
      return (
        <div
          key={color}
          className="color"
          onClick={() => setSelectedColor(color)}
          style={{
            color: getContrastingTextColor(color),
            backgroundColor: color,
            borderRadius: selectedColor === color ? "5px" : "50%",
          }}
        >
          {selectedColor === color && <FontAwesomeIcon icon={faCheck} />}
        </div>
      );
    });
  };

  return (
    <div className="color-picker-container" ref={dropdownRef}>
      <div
        className="display-wrapper"
        style={{ color: initialColor }}
        onClick={() => {
          if (!alwaysOpen) {
            setIsPickerOpen(!isPickerOpen);
          }
        }}
      >
        {display ? (
          display
        ) : (
          <div
            className="default-display-wrapper"
            style={{
              backgroundColor: selectedColor,
            }}
          ></div>
        )}
      </div>
      {(isPickerOpen || alwaysOpen) && (
        <div className="color-picker-wrapper">
          <label>Select a Color</label>
          <div className="default-colors-wrapper">{renderColors()}</div>
          <div className="color-input-wrapper">
            <input
              type="color"
              name="color-picker"
              id="color-picker"
              value={selectedColor}
              onChange={(e) => setSelectedColor(e.target.value)}
            />
            <button
              type="button"
              disabled={initialColor === selectedColor}
              onClick={async () => {
                try {
                  const result = handleColor(selectedColor);
                  if (result?.then) {
                    await result;
                  }
                  if (onClose) {
                    onClose();
                  } else {
                    setIsPickerOpen(false);
                  }
                } catch (err) {
                  console.error("Color save failed:", err);
                }
              }}
              className="small"
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
